import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider, Helmet } from "react-helmet-async";
import Header from "./components/header/Header";
import StrategyCreator from "./screens/StrategyCreator/StrategyCreator";
import Positions from "./screens/Positions/Positions";
// import Orders from "./screens/Orders/Orders";
import Orders from "./screens/OrdersPage/OrdersPage";
import OptionChain from "./screens/OptionChain/OptionChain";
import Watchlist from "./screens/Watchlist";
import VirtualPositions from "./screens/virtualScreens/Positions/VirtualPositions";
import VirtualOrders from "./screens/virtualScreens/Orders/VirtualOrders";
import RiskDisclosure from "./modals/RiskDisclosure";
import { ButtonContext } from "./context/ButtonsContext";
import Screener from "./screens/Screener";
import ScreenersDetail from "./screens/ScreenersDetail";
import StockDetails from "./screens/StockDetails/StockDetails";
import MobileAppAnnouncement from "./components/MobileAppAnnouncement";
import ReportsPage from "./screens/Reports/pages/ReportsPage";
import GlobalMarket from "./screens/GlobalMarket/GlobalMarket";
import OptionChainScreen from "./screens/OptionChainScreen/OptionChainScreen";
import CalculatorsPage from "./screens/Calculators/CalculatorsPage";
import Scanners from "./screens/Scanners/Scanners";
import NewScanners from "./screens/Scanners/NewScanners";
import StockPage from "./screens/StockPage/StockPage";
import Charts from "./screens/Charts/Charts";
import GlobalChatButton from "./components/GlobalChatButton";

function App() {
  const { isVirtual } = useContext(ButtonContext);
  const location = useLocation();

  const PositionsComponent = isVirtual ? Positions : Positions;
  const OrdersComponent = isVirtual ? Orders : Orders;
  const isScannerRoute = location.pathname === "/scanners";
  const isNewScannersRoute = location.pathname === "/scanners-new" || location.pathname.startsWith("/scanners/stock");

  // useEffect(() => {
  //   const screenWidth = window.screen.width;
  //   if (screenWidth > 1300 && screenWidth < 1396) {
  //     document.documentElement.style.zoom = "90%";
  //   }
  //   return () => {
  //     document.documentElement.style.zoom = "100%"; // Reset zoom when component unmounts
  //   };
  // }, []);

  return (
    <HelmetProvider>
      <Helmet>
        {/* Note: Most security headers can only be set via HTTP response headers, not HTML meta tags */}
        {/* Only CSP and referrer policy work via meta tags */}
        
        <meta name="referrer" content="strict-origin-when-cross-origin" />
        <meta
          httpEquiv="Content-Security-Policy"
          content="default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://www.googletagmanager.com https://www.google-analytics.com https://cdnjs.cloudflare.com; style-src 'self' 'unsafe-inline' https://cdnjs.cloudflare.com https://unpkg.com https://fonts.googleapis.com; font-src 'self' https://cdnjs.cloudflare.com https://fonts.gstatic.com; img-src 'self' data: https: http: https://dpx2abi6sh9y5.cloudfront.net; connect-src 'self' https://*.execute-api.ap-south-1.amazonaws.com https://f5zy.aliceblueonline.com https://ws1.aliceblueonline.com https://v2api.aliceblueonline.com wss://ws1.aliceblueonline.com wss://f5zy.aliceblueonline.com https://www.google-analytics.com https://analysis.clnk.ai https://tvsymbols-cache.s3.ap-south-1.amazonaws.com; frame-src 'self' http://localhost:5000 https://dpx2abi6sh9y5.cloudfront.net https://d2cu2jxbfa1nts.cloudfront.net https://charts.1lyoptions.com; frame-ancestors 'none'; object-src 'none'; base-uri 'self'; form-action 'self';"
        />

        {/* Banner grabbing prevention */}
        <meta name="generator" content="" />
      </Helmet>
      <ToastContainer />
      <Header />
      <RiskDisclosure />
      {/* <MobileAppAnnouncement /> */}
      <div className={`grid-container ${location.pathname === "/charts" ? "charts-screen" : ""}`}>
        {/* <ChatbotEmbed /> */}
        <Routes>
          <Route path="/" element={<StrategyCreator />} />
          <Route path="/optionchain" element={<OptionChainScreen />} />
          <Route path="/optionchain/:symbol" element={<OptionChainScreen />} />
          <Route path="/positions" element={<PositionsComponent />} />
          <Route path="/orders" element={<OrdersComponent />} />
          <Route path="/screeners/:type" element={<Screener />} />
          <Route path="/screenerDetails" element={<ScreenersDetail />} />
          <Route path="/StockDetails" element={<StockDetails />} />
          <Route path="/watchlist" element={<Watchlist />} />
          <Route path="/discover" element={<GlobalMarket />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/calculators" element={<CalculatorsPage />} />
          <Route path="/charts" element={<Charts visible={true} />} />
          <Route path="/scanners" element={<NewScanners />} />
          <Route path="/scanners/stock" element={<StockPage />} />
        </Routes>
        {/* <Scanners visible={isScannerRoute} /> */}
        {/* Old Flutter iframe scanner - replaced with React implementation */}
      </div>
      <GlobalChatButton />
    </HelmetProvider>
  );
}

export default App;
